import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/vexubweb/app/[locale]/HotjarDelayed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PixelInits"] */ "/var/www/html/vexubweb/app/[locale]/pixelsInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/vexubweb/app/[locale]/utils/setFirstTimeUrl.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/vexubweb/app/TRACKER/VexubTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/vexubweb/components/TranslateErrorBoundaryWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/var/www/html/vexubweb/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SecureCookiesProvider"] */ "/var/www/html/vexubweb/node_modules/next-client-cookies/dist/provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/vexubweb/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/next/dist/client/script.js");
